module.exports = __webpack_public_path__ + "static/media/w-delay-logo-green.c92804a2.png";